// Shared utility functions for review functionality

export interface Review {
  email: string;
  user_id: string;
  username: string;
  rating: number;
  comment: string;
  created_at: number | string;
  updated_at: number | string;
  review_id: string;
  title: string;
}

export interface UserAccount {
  idTokenClaims: {
    oid: string;
  };
  username: string;
  name: string;
}

export const getUserReview = (reviews: Review[], oid: string, email: string, username: string): Review | undefined => {
  return reviews.find((r: Review) => r.user_id === oid || r.email === email || r.username === username);
};

export const extractUserData = (account: UserAccount) => {
  return {
    oid: account.idTokenClaims.oid,
    email: account.username,
    name: account.name,
  };
};

export const createReviewPayload = (rating: number, comment: string, username: string, email: string) => {
  return {
    rating,
    comment: comment.trim(),
    username,
    email,
  };
};
